"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Walking on nodes tree from the element to root or provided end element.
 * Do not visit the sibling and children.
 *
 * @param node start node
 * @param nodeAction action for every node, if return false walk will be break
 */
function walkToTop(node, nodeAction) {
    if (nodeAction(node) !== false && node.parentNode !== null) {
        walkToTop(node.parentNode, nodeAction);
    }
}
exports.walkToTop = walkToTop;
/**
 * Return first ancestor, for wich predicate returns true
 * If nothing found, returns null
 */
function findAncestor(node, predicate) {
    var ancestor = null;
    walkToTop(node.parentNode, function (candidate) {
        if (predicate(candidate)) {
            ancestor = candidate;
            return false;
        }
    });
    return ancestor;
}
exports.findAncestor = findAncestor;
/**
 * Walking on nodes tree from the element to latest leaf or provided end element.
 * Visit all children and siblings. Walk is in "reading" order (Depth-first search).
 *
 * @param node start node
 * @param nodeAction action for every node, if return false walk will be break
 */
function walkOverTree(node, nodeAction) {
    var currentNode = node;
    var endNode = getSibling(node);
    while (currentNode) {
        if (currentNode === endNode) {
            break;
        }
        if (nodeAction(currentNode) !== false) {
            if (currentNode.hasChildNodes()) {
                currentNode = currentNode.childNodes.item(0);
            }
            else {
                currentNode = getSibling(currentNode);
            }
        }
        else {
            break;
        }
    }
}
exports.walkOverTree = walkOverTree;
/**
 * Walking on nodes tree from provided node to provided root element.
 * Walk is inverse walkOverTree.
 *
 * @param node
 * @param rootElement
 * @param nodeAction
 */
function reverseWalkOverTree(node, rootElement, nodeAction) {
    var currentNode = node;
    var endNode = getPreviousSibling(rootElement, true);
    while (currentNode) {
        if (currentNode === endNode) {
            break;
        }
        if (nodeAction(currentNode) !== false) {
            currentNode = getPreviousSibling(currentNode, true);
        }
        else {
            break;
        }
    }
}
exports.reverseWalkOverTree = reverseWalkOverTree;
/**
 * Looking for last child node in current node.
 * Return lastChild node or start node.
 *
 * @param node Start node
 */
function findLastNode(node) {
    var currentNode = node;
    while (currentNode) {
        if (currentNode.lastChild) {
            currentNode = currentNode.lastChild;
        }
        else {
            return currentNode;
        }
    }
    return node;
}
exports.findLastNode = findLastNode;
/**
 * Looking for next sibling in tree.
 * Returns the next sibling of node or of parent or grandparent or ...
 *
 * @param node Start node
 */
function getSibling(node) {
    var currentNode = node;
    if (currentNode.nextSibling) {
        return currentNode.nextSibling;
    }
    while (currentNode && currentNode.parentNode) {
        if (currentNode.parentNode.nextSibling) {
            return currentNode.parentNode.nextSibling;
        }
        else {
            currentNode = currentNode.parentNode;
        }
    }
    return null;
}
exports.getSibling = getSibling;
/**
 * Looking for previous sibling in tree.
 * Returns the previous sibling of node or of parent or grandparent or ...
 *
 * @param node Start node
 * @param skipChilds for skipping childs because childs of nodes can't be previous in reverse DFS
 */
function getPreviousSibling(node, skipChilds) {
    if (skipChilds === void 0) { skipChilds = false; }
    var currentNode = node;
    if (skipChilds) {
        if (currentNode.previousSibling) {
            return getPreviousSibling(currentNode.previousSibling);
        }
        else {
            return currentNode.parentNode;
        }
    }
    while (currentNode) {
        if (currentNode.lastChild) {
            currentNode = currentNode.lastChild;
        }
        else {
            return currentNode;
        }
    }
    return currentNode; // null since while-loop finished
}
exports.getPreviousSibling = getPreviousSibling;
/**
 * Check is first provided element a child of second provided element
 *
 * @param element child
 * @param suspectedParent and parent
 */
function isChildOf(element, suspectedParent) {
    var parent = element.parentNode;
    while (parent) {
        if (parent === suspectedParent) {
            return true;
        }
        else {
            parent = parent.parentNode;
        }
    }
    return false;
}
exports.isChildOf = isChildOf;
